import React,{ useEffect, useState } from 'react';
import {Page } from 'react-weui';
import { Toast } from 'antd-mobile';
import { mySubscriptionProgram } from '@/services/program';
import Empty from '@/components/empty';
import styles from './styles.scss';
import { history } from 'umi';


export default (props) => {

  const [dataList, setDataList] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0); // 新增总条数

  useEffect(() => {

    getList(1);

  }, []);

  function getList(pageNo,resolve, finish) {
    mySubscriptionProgram({pageNo:pageNo, pageSize:20}).then(res => {
      console.log(res);
      if (res.code == 200) {
        setTotalCount(res.data.count || 0); // 更新总条数
        if (pageNo == 1) {
          setDataList(res.data.list);
        } else {
          setDataList(prev => prev.concat(res.data.list));
        }
        setPageNo(pageNo);
        resolve && resolve();
        // 不再用list.length判断finish，由onLoadMore统一判断

      } else {
        Toast.fail(res.message,1);
        resolve && resolve();
      }

    }).catch(e =>{
      Toast.fail('请求失败，请重试',1);
      resolve && resolve();
    });
  }


  return (
    <Page transition={true} infiniteLoader={true} ptr={false}
          onLoadMore={ (resolve, finish) => {
            if (dataList.length >= totalCount && totalCount !== 0) {
              finish();
              return;
            }
            getList(pageNo+1,resolve,finish);

          }}>


      {

        dataList.length ? dataList.map(item => (
          <div className={styles.item_box} key={item.id} onClick={() =>{
            history.push('/program/programDetail?programId=' + item.columnId  + '&title=' + item.column.name);

          }}>

            <img alt='' src={item.column.image} />

            <div className={styles.item_content}>
              <label className={styles.item_title}>{item.column.name}</label>
              <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                <label className={styles.item_subtitle}>{'更新至：' + item.columnVideo.dateName}</label>
                <label className={styles.item_status}>{item.column.isEnd == '0' ? '更新中' : ' 已完结'}</label>
              </div>
            </div>
          </div>
        )) :<Empty text={'暂无数据'}/>
      }
      {dataList.length >= totalCount && totalCount !== 0 && (
        <div style={{ textAlign: 'center', color: '#888', padding: '12px 0' }}>
          没有更多数据了
        </div>
      )}
    </Page>
  )
}
